/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReplicationFactorChangeResponse
 */
export interface ReplicationFactorChangeResponse {
    /**
     * 
     * @type {number}
     * @memberof ReplicationFactorChangeResponse
     */
    totalReplicationFactor: number;
    /**
     * 
     * @type {string}
     * @memberof ReplicationFactorChangeResponse
     */
    topicName: string;
}

export function ReplicationFactorChangeResponseFromJSON(json: any): ReplicationFactorChangeResponse {
    return ReplicationFactorChangeResponseFromJSONTyped(json, false);
}

export function ReplicationFactorChangeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplicationFactorChangeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalReplicationFactor': json['totalReplicationFactor'],
        'topicName': json['topicName'],
    };
}

export function ReplicationFactorChangeResponseToJSON(value?: ReplicationFactorChangeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalReplicationFactor': value.totalReplicationFactor,
        'topicName': value.topicName,
    };
}

